import React, { Component } from 'react'
import './slider.css'
export default class Slogan extends Component {


    render() {

        return(
          <div className="centerSlogan">
          <div className='slogan' id="slideset2" >
            Archive&nbsp;<b>memories</b>
                         <b>games</b>
                         <b>values</b>
          </div>
          </div>

        )
    }
}